import React from 'react';
import PropTypes from 'prop-types';

import ReactTooltip from 'react-tooltip';

import QuestionIcon from './QuestionIcon';

const TooltipIcon = (props) => {
    const {
        text,
        containerClassName,
        iconClassName,
        multiline
    } = props;

    return (
        <div
            className={containerClassName}
            data-tip={text}
            data-place="right"
            data-type="info"
            data-multiline={multiline}
        >
            <QuestionIcon
                className={iconClassName}
            />
            <ReactTooltip/>
        </div>
    );
};

TooltipIcon.propTypes = {
    text: PropTypes.string.isRequired,
    containerClassName: PropTypes.string,
    iconClassName: PropTypes.string,
    multiline: PropTypes.bool,
};
TooltipIcon.defaultProps = {
    containerClassName: null,
    iconClassName: null,
    multiline: true,
};

export default TooltipIcon;



// WEBPACK FOOTER //
// ./src/components/controls/icons/TooltipIcon.jsx